<template>
  <TheAdmin :color="true" title="장소" description="장소를 선택할 수 있어요.">
    <a-card title="카테고리">
      <a-transfer
        :dataSource="locations"
        showSearch
        @change="(keys) => target = keys"
        :operations="['선택', '해제']"
        :targetKeys="target"
        :render="l => l.title"
        :listStyle="{
      width: isPC ? '40%' : '100%',
      height: '500px',
    }"
      >
        <span slot="notFoundContent">결과 없음</span>
      </a-transfer>
    </a-card>
    <a-button style="margin-top: 10px;" @click="onApply" type="primary" icon="save">저장</a-button>
  </TheAdmin>
</template>
<script>
import TheAdmin from "@/components/Admin/TheAdmin";
import Axios from "axios";
import config from "../../config";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import OPCODE from "../../libs/OPCODE";

export default {
  name: "AdminQuestion",
  components: { TheAdmin },
  mounted() {
    this.onRefresh();
  },
  methods: {
    async onRefresh() {
      try {
        const { data } = await Axios.get(
          `${config.hostname}/v1/admin/location`,
          {
            withCredentials: true
          }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.target = data.target;
              this.locations = data.location;
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "장소 정보를 가져올 수 없습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "장소 정보를 가져올 수 없습니다."
        });
      }
    },
    async onApply() {
      try {
        const { data } = await Axios.post(
          `${config.hostname}/v1/admin/location`,
          { target: this.target },
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.onRefresh();
              config.alert.mixin({
                type: "success",
                title: "반영되었습니다."
              });
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "장소 정보를 가져올 수 없습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "장소 문의 정보를 가져올 수 없습니다."
        });
      }
    }
  },
  data() {
    return {
      selected: "",
      category: "",
      locations: [],
      secondary: [],
      target: [],
      secondaryCategory: ""
    };
  }
};
</script>
<style scoped>
.ant-card-body {
  padding: 0px;
}

.ant-collapse-content > .ant-collapse-content-box {
  padding: 2px;
}
</style>